import {cssTheme as rawCssTheme} from '@vio/atlas-tokens'

import {fonts} from './fonts'
import {typography} from './typography'

export enum ThemeNames {
  dealbase = 'dealbase',
  goseek = 'goseek',
  kayak = 'kayak',
  kiwi = 'kiwi',
  vio = 'vio',
  holidaypirates = 'holidaypirates',
  weward = 'weward',
  ovago = 'ovago',
  karmanow = 'karmanow',
  finn = 'finn',
  hotelix = 'hotelix',
  elal = 'elal',
  novaair = 'novaair'
}

const {
  opacity,
  layout,
  shadow: shadows,
  components,
  semantic,
  custom,
  primitive
} = rawCssTheme

export const cssTheme = {
  colors: {
    ...components,
    ...custom,
    ...semantic,
    ...primitive
  },
  opacity,
  layout,
  shadows,
  fonts,
  typography
}
